"use client";

import { useState } from "react";
import CommunityMembersModal from "../members/members-modal";
import StatisticCard from "./statistic-card";

const CommunityStats = ({
	totalPosts,
	totalMembers,
	totalViews,
}: {
	totalPosts: number;
	totalMembers: number;
	totalViews: number;
}) => {
	const statistics = [
		{ label: "Posts", value: totalPosts, bgColor: "bg-blue-100" },
		{
			label: "Members",
			value: totalMembers,
			bgColor: "bg-purple-200",
		},
		{
			label: "Views",
			value: totalViews,
			bgColor: "bg-neutral-200",
		},
	];

	const [showMembersModal, setShowMembersModal] = useState<boolean>(false);

	return (
		<>
			<div className="mt-2 flex max-w-lg items-center justify-start gap-2">
				{statistics.map((stat, index) => (
					<StatisticCard
						key={index}
						label={stat.label}
						numericValue={stat.value}
						bgColor={stat.bgColor}
						onClick={stat.label === "Members" ? () => setShowMembersModal(true) : undefined}
					/>
				))}
			</div>

			<CommunityMembersModal open={showMembersModal} setOpen={setShowMembersModal} />
		</>
	);
};

export default CommunityStats;
